import { CustomSelect } from "@/components/CustomSelect/CustomSelect";
import LabelWithToolTip from "@/components/LabelWithTooltip/LabelWithToolTip";
import { useMetadataFields } from "@/components/MetadataFields/hooks";
import { hasStringKey } from "@/utils/misc";
import Label from "@ingka/label";
import { getOptions, validateOutput } from "./utils";

type Props = {
  disabled: boolean;
  options: Record<string, string>;
  tooltip: string;
};

const NegotiatedUsageRights = ({ tooltip, options, disabled }: Props) => {
  const {
    getValidationError,
    activeAsset,
    updateMetadata,
    isMetadataUpdating,
  } = useMetadataFields();
  const negotiatedUsageRights = activeAsset.negotiatedUsageRights || [];
  const error = getValidationError("negotiatedUsageRights", activeAsset.id!);
  const isUpdating = isMetadataUpdating(
    activeAsset.id!,
    "negotiatedUsageRights",
  );

  return (
    <>
      <Label
        htmlFor="negotiatedUsageRights"
        label={
          <LabelWithToolTip
            labelText="Negotiated usage rights"
            toolTipText={tooltip}
          />
        }
      />
      <CustomSelect
        id="negotiatedUsageRights"
        isMulti={true}
        placeholder="Select negotiated usage rights"
        disabled={disabled || isUpdating}
        errorMessage={error?.message}
        options={getOptions(options, negotiatedUsageRights)}
        value={negotiatedUsageRights.map((ur) => ({
          label: options[ur],
          value: ur,
        }))}
        onChange={(values) => {
          if (
            Array.isArray(values) &&
            values.filter((option) => hasStringKey("value", option))
          ) {
            updateMetadata({
              negotiatedUsageRights: validateOutput(
                values.map((item) => item.value),
              ),
            });
          }
        }}
      />
    </>
  );
};

export default NegotiatedUsageRights;
